import React from "react";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import PostAddIcon from "@mui/icons-material/PostAdd";
import DeleteForeverOutlinedIcon from "@mui/icons-material/DeleteForeverOutlined";
import { formatDate } from "../../../utils/dateFormat";
import axios from "axios";

const columns = [
  { id: "interestid", label: "#", minWidth: 100 },
  { id: "userName", label: "Name", minWidth: 170 },
  { id: "title", label: "Product Title", minWidth: 170 },
  { id: "prdImage", label: "Image", minWidth: 170 },
  { id: "createdAt", label: "Created At", minWidth: 170 },
  { id: "action", label: "Action", minWidth: 170 },
];

const Interests = () => {
  const apiUrl = process.env.REACT_APP_API_URL;
  const [Ainterests, setInterests] = React.useState([]);
  const location = useLocation();
  const navigate = useNavigate();

  React.useEffect(() => {
    if (location.state && location.state.message) {
      toast.success(location.state.message);
      navigate(location.pathname, { replace: true });
    }
  }, [location.state, navigate]);

  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const fetchInterests = async () => {
    try {
      const response = await axios.get(`${apiUrl}/getAllInterests`);
      if (response.status === 200) {
        const sortedInterests = response.data.interests.sort(
          (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
        );
        setInterests(sortedInterests);
      } else {
        toast.success("Failed to fetch interests.");
      }
    } catch (error) {
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        toast.error(`Error: ${error.response.data.message}`);
      } else {
        toast.error("An error occurred. Please try again later.");
      }
    }
  };
  React.useEffect(() => {
    fetchInterests();
  }, []);

  const handleDelete = async (interestId) => {
    if (window.confirm("Are you sure you want to delete this interest?")) {
      try {
        const response = await axios.delete(
          `${apiUrl}deleteInterest/${interestId}`
        );
        if (response.status === 200) {
          toast.success("Interest deleted successfully.");
          fetchInterests();
        } else {
          toast.error("Failed to delete Interest.");
        }
      } catch (error) {
        console.error("Error deleting Interest:", error);
        toast.error("Error deleting Interest.");
      }
    }
  };
  return (
    <div className="dashboard-content-wrap p-10">
      <ToastContainer />
      <div className="box-card">
        <div className="box-card-title mb-4">
          <h1 className="text-lg font-medium flex items-center">
            All Interests
          </h1>
        </div>
        <div className="box-card-body">
          <Paper sx={{ width: "100%", overflow: "hidden" }}>
            <TableContainer>
              <Table stickyHeader aria-label="sticky table">
                <TableHead>
                  <TableRow>
                    {columns.map((column) => (
                      <TableCell
                        key={column.id}
                        style={{ minWidth: column.minWidth }}
                      >
                        {column.label}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {Ainterests.map((interest, index) => (
                    <TableRow hover key={index}>
                      <TableCell>{index + 1}</TableCell>
                      <TableCell>
                        {interest.userId?.name || "No Name"}
                      </TableCell>
                      <TableCell>
                        {interest.productId?.title || "No Title"}
                      </TableCell>
                      <TableCell>
                        <img
                          src={interest.productId?.images[0] || "No Image"}
                          className="h-[100px] w-[100px] object-cover rounded-md"
                        />
                      </TableCell>
                      <TableCell>{formatDate(interest.createdAt)}</TableCell>
                      <TableCell>
                        <Link
                          to={`/admin/dashboard/detailInterest/${interest._id}`}
                        >
                          <PostAddIcon />
                        </Link>

                        <DeleteForeverOutlinedIcon
                          onClick={() => handleDelete(interest._id)}
                          style={{ cursor: "pointer", color: "red" }}
                        />
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
            <TablePagination
              rowsPerPageOptions={[10, 25, 100]}
              component="div"
              count={Ainterests.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </Paper>
        </div>
      </div>
    </div>
  );
};

export default Interests;
